import React from 'react'

export default () => <div><h2> EULA </h2></div>
